import api from './authService';

export const getMeetings = () => {
  return api.get('/meetings');
};

export const getMeeting = (id) => {
  return api.get(`/meetings/${id}`);
};

export const uploadMeeting = (formData, onUploadProgress) => {
  return api.post('/meetings/upload', formData, {
    onUploadProgress,
  });
};

export const deleteMeeting = (id) => {
  return api.delete(`/meetings/${id}`);
};

export const updateMeeting = (id, data) => {
  return api.put(`/meetings/${id}`, data);
};

export const reprocessMeeting = (id) => {
  return api.post(`/meetings/${id}/reprocess`);
};

export const resubmitMeeting = (id) => {
  return api.post(`/meetings/${id}/resubmit`);
};

export const transcribeMeeting = (id) => {
  return api.post(`/meetings/${id}/transcribe`);
};

export const getMeetingDownloadUrl = (id) => {
  return api.get(`/meetings/${id}/download`);
};

export const createShareLink = (id, expirationDays = 7) => {
  return api.post(`/meetings/${id}/share`, { expirationDays });
};

export const getSharedMeeting = (token) => {
  return api.get(`/meetings/shared/${token}`);
};

export const getMeetingArtifacts = (id) => {
  return api.get(`/meetings/${id}/artifacts`);
};

/**
 * Download a meeting recording as a blob, triggering a browser download.
 * @param {string} id
 * @param {Object} [options]
 * @param {(event: {loaded: number, total?: number}) => void} [options.onDownloadProgress]
 * @returns {Promise<Blob>}
 */
export const downloadMeetingRecording = (id, { onDownloadProgress } = {}) => {
  return api.get(`/meetings/${id}/download`, {
    responseType: 'blob',
    onDownloadProgress,
  });
};

/**
 * Download an artifact through the authenticated server-side proxy.
 * @param {string} id - Meeting id.
 * @param {string} artifactId - Manifest artifact id (never a raw object key).
 * @param {Object} [options]
 * @param {(event: {loaded: number, total?: number}) => void} [options.onDownloadProgress]
 * @returns {Promise<Blob>}
 */
export const downloadMeetingArtifact = (id, artifactId, { onDownloadProgress } = {}) => {
  return api.get(`/meetings/${id}/artifacts/${artifactId}/download`, {
    responseType: 'blob',
    onDownloadProgress,
  });
};